module.exports = __webpack_public_path__ + "img/error.7dd02c3.png";